import React, { useState, useEffect } from "react";
import InputWrapper from './InputWrapper'
import { useForm } from './useForm'
import validator from 'validator'
// import accents from 'remove-accents'
import Button from '../../components/Button'
import { useTranslation } from 'react-i18next'

import { customValidation } from './formFunctions'

// NOTE: The type = "text" declaration below serves as a default value for that component property
export default function Input({ label, name, value = '', type = "text", inputMode = 'text', id, min, max, maxLength, required = false, validate, onChange, placeholder, regex, autoComplete = 'on', formatting=[], disabled, error, errorMessage, defaultValue, icon, className, isSearch, clearSearchDisabled, handleClearSearch }) {
    const { t } = useTranslation()
    
    // const [stateValue, setValue] = useState(value);
    const [isFocused, setFocus] = useState(false)

    // Use global form state
    const [{ inputs }, setFormValue] = useForm()

    const [ errorMsg, setErrorMsg ] = useState('')

    // On init, set object name
    useEffect(() => {
        if (!inputs[name] || (id && !inputs[name][id])) {
            setFormValue({
                [name]: value
            }, id)
        }
        // eslint-disable-next-line
    }, [])

    const inputId = `f_${name}${id > -1 ? `_${id}` : ''}`

    if (autoComplete === 'on') {
        if (name === 'username') {
            autoComplete = 'username'
        }
        if (type === 'password') {
            autoComplete = 'current-password'
        }
    }

    function handleInputValidation(value) {

        let error = false
        if (required && validator.isEmpty(value)) error = true
        if (inputMode === 'tel' && value && !validator.isMobilePhone(value, 'en-CA')) error = true
        if (inputMode === 'email' && value && !validator.isEmail(value)) error = true
        // if (inputMode === 'number' && value && !validator.isNumeric(value, { no_symbols: true })) error = true
        if (validate && !customValidation(value, validate)) error = true

        if (error) {
            setErrorMsg(errorMessage)
        }
        else {
            setErrorMsg('')
        }

    }

    return (
        <InputWrapper label={label} inputId={inputId} isFocused={ isFocused } isFilled={ (id > -1 && inputs[name] && inputs[name][id]) || (!id && id !== 0 && inputs[name]) ? true : false } error={ errorMsg } className={className}>
            <input 
                id={inputId}
                type={type}
                inputMode={ inputMode }
                name={name}
                min={type === 'number' ? min : null}
                max={type === 'number' ? max : null}
                // required={required}
                value={ id > -1 && inputs[name] ? (inputs[name][id] || '') : (inputs[name] || '') }
                onChange={e => {
                    let formattedValue = regex ?
                        e.target.value.replace(regex[0],regex[1])
                    : e.target.value

                    formatting.map(format => {
                        if (format === 'uppercase') return formattedValue = formattedValue.toUpperCase()
                        return null
                    })

                    if (maxLength) formattedValue = formattedValue.substr(0, maxLength)

                    // formattedValue = validator.escape(formattedValue)

                    setFormValue({
                        [name]: formattedValue
                    }, id);

                    handleInputValidation(formattedValue)

                    // Allow listening to onChange for this specific input
                    if (onChange) onChange({ target: { name: e.target.name, value: formattedValue } })
                }}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                autoComplete={ autoComplete }
                placeholder={placeholder}
                disabled={disabled}
                defaultValue={defaultValue}
            />
            { isSearch && 
                <Button onClick={ handleClearSearch } 
                        context='yellow'
                        className='input-search'
                        disabled={ clearSearchDisabled }
                >
                    { t('clearSearchBtn', 'Clear Search') }
                </Button>
            }
            { icon && <i className='material-icons'>{ icon }</i> }
            {
                required ? 
                <span className="required-hint"></span> 
                :
                null
            }
        </InputWrapper>
    );
}
